import { ArgsType, Field, Int } from '@nestjs/graphql'
import { BaseGetArgs } from '../../base/baseGet.args'

@ArgsType()
export class UserStatusGetArgs extends BaseGetArgs<UserStatusGetArgs> {
  @Field(t => Int)
  userId!: number

  @Field({ nullable: true })
  needle?: string

  @Field(t => Int, { nullable: true })
  adminUserId?: number

  @Field(t => Int, { nullable: true })
  type?: number

  @Field({ nullable: true })
  active?: boolean

  @Field({ nullable: true })
  isRestriction?: boolean
}
